import React from 'react';
const CategoriesIcon = () => (
  <svg width="17" height="14" viewBox="0 0 17 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M0.75 2C0.75 0.90625 1.625 0 2.75 0H14.75C15.8438 0 16.75 0.90625 16.75 2V12C16.75 13.125 15.8438 14 14.75 14H2.75C1.625 14 0.75 13.125 0.75 12V2ZM15.25 12V7.75H4.75V12.5H14.75C15 12.5 15.25 12.2812 15.25 12ZM15.25 6.25V2C15.25 1.75 15 1.5 14.75 1.5H4.75V6.25H15.25Z"
      fill="#10182B"
    />
  </svg>
);

export default CategoriesIcon;
